module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/json-loader!./.cache/json/components-text.json
// module id = 1034
// module chunks = 260502274512611